
export const ReloadGridAction = (data) => {
  return ({
    type :'ReloadGridAction',
    payload: data
  })
}

export default ReloadGridAction